"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var link_1 = __importDefault(require("next/link"));
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var AcceptPolicy = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    var lang = (0, next_intl_1.useLocale)();
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var config = (0, swr_hooks_1.useConfig)();
    var usePromoConsentText = Boolean(config === null || config === void 0 ? void 0 : config.acceptPolicyWithPromos);
    if (usePromoConsentText) {
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.acceptTerms },
            react_1.default.createElement(react_final_form_1.Field, { name: "acceptTerms", render: function (_a) {
                    var input = _a.input, meta = _a.meta;
                    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                        react_1.default.createElement(ui_components_1.InputCheckbox, __assign({ id: "acceptTerms", label: "" }, input, { type: "checkbox", checked: input.value, isActive: input.value })),
                        react_1.default.createElement("label", { htmlFor: "acceptTerms", className: styles_module_scss_1.default.acceptText },
                            t('acceptTerms18'),
                            ' ',
                            react_1.default.createElement(link_1.default, { href: generateUrlWithLang((config === null || config === void 0 ? void 0 : config.generalTermsAndConditionsLink) || '/terms-of-use'), target: "_blank" }, t('theTermsAndConditions')),
                            ', ',
                            react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/privacy-policy"), target: "_blank" }, t('privacyPolicy')),
                            ' ',
                            t('acceptTermsPromos')),
                        meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, { style: {
                                textAlign: 'center',
                                width: 'auto',
                                position: 'inherit',
                            } }, meta.error))));
                } })));
    }
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.acceptTerms },
        react_1.default.createElement(react_final_form_1.Field, { name: "acceptTerms", render: function (_a) {
                var input = _a.input, meta = _a.meta;
                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                    react_1.default.createElement(ui_components_1.InputCheckbox, __assign({ id: "acceptTerms", label: "" }, input, { type: "checkbox", checked: input.value, isActive: input.value })),
                    react_1.default.createElement("label", { htmlFor: "acceptTerms", className: styles_module_scss_1.default.acceptText },
                        t('acceptTerms18'),
                        ' ',
                        react_1.default.createElement(link_1.default, { href: generateUrlWithLang((config === null || config === void 0 ? void 0 : config.generalTermsAndConditionsLink) || '/terms-of-use'), target: "_blank" }, t('theTermsAndConditions')),
                        ' ',
                        t('and'),
                        ' ',
                        react_1.default.createElement(link_1.default, { href: "/".concat(lang, "/privacy-policy"), target: "_blank" }, t('privacyPolicy'))),
                    meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, { style: {
                            textAlign: 'center',
                            width: 'auto',
                            position: 'inherit',
                        } }, meta.error))));
            } })));
};
exports.default = AcceptPolicy;
